import { type FilterValues } from "components/filters/FilterContext";
import { DefaultClientFileSortFilter, getSortOption } from "components/filters/Filters/FilterTypes/ClientFileSortFilterType";
import { mapKeywordFilterToInstruction, mapOnlyMySelectionFilterToInstruction, mapResponseToKeywordFilter, mapResponseToOnlyMySelectionFilter, mapResponseToVisibilityFilter, mapVisibilityFilterToInstruction } from "components/filters/mappingUtils";

export const mapFilterValuesToInstruction = (
  filterSet: server.dto.FilterSets,
  filter: FilterValues,
  page: number,
  perPage: number
): server.dto.PaginatedClientFileInstruction => {
  return {
    keyword: mapKeywordFilterToInstruction(filter.keyword),
    onlyMySelection: mapOnlyMySelectionFilterToInstruction(filter.onlyMySelection),
    visibleToExternal: mapVisibilityFilterToInstruction(filter.visible),
    order: filter.clientFileSort.sortOption.value,
    page,
    perPage,
    cache: filterSet,
  };
};

export const mapResponseToFilterValues = (
  response: server.dto.ListClientFileFilters,
  _: FilterValues
): Partial<FilterValues> => ({
  keyword: mapResponseToKeywordFilter(response.keyword),
  onlyMySelection: mapResponseToOnlyMySelectionFilter(response.onlyMySelection),
  visible: mapResponseToVisibilityFilter(response.visibleToExternal),
  clientFileSort: {
    sortOption: response.sort !== "dateDesc"
      ? getSortOption(response.sort)
      : getSortOption(DefaultClientFileSortFilter),
  }
});
